<template>
  <div
    class="flex items-center gap-2 p-4 w-full"
    :class="{ 'opacity-50 cursor-not-allowed': isDisabled }"
  >
    <ThemeImage
      :icon="imageNames.LINKEDIN"
      alt="linkedin"
      class="size-4"
    />
    <div class="flex justify-between w-full items-center">
      <span class="text-sm">{{ accountName }}</span>
      <span
        v-if="linkedinAccount.status === 'Disconnected'"
        class="text-sm"
        style="color: var(--paused-icon)"
      >
        Disconnected
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
});

const linkedinAccount = computed(() => props.row);

const isDisabled = computed(() => {
  return linkedinAccount.value.status === 'Disconnected' || linkedinAccount.value.disabled;
});

const accountName = computed(() => {
  const account = linkedinAccount.value;
  // Show account name with email if available, otherwise just the name
  if (account.user_email) {
    const displayName = account.account_name || account.user_name || 'Unknown User';
    return `${displayName} (${account.user_email})`;
  }
  return account.account_name || account.user_name || 'Unknown User';
});
</script>
